import { server } from 'helpers/config';

const SERVER_URL = server.apiHost;

export default {
  INFO: `${SERVER_URL}/t2b/documents/kw-articles-list/`,
};